import type { LoopIterationContext } from '../../../api/types';

export type LoopIterationDisplay = {
  current: number;
  total: number;
};

export function getLoopIterationDisplay(
  loopIteration?: LoopIterationContext | null
): LoopIterationDisplay | null {
  if (!loopIteration) {
    return null;
  }

  const { iterationIndex, iterationTotal } = loopIteration;
  if (
    !Number.isFinite(iterationIndex) ||
    !Number.isFinite(iterationTotal) ||
    iterationIndex < 0 ||
    iterationTotal <= 0
  ) {
    return null;
  }

  return {
    current: iterationIndex + 1,
    total: iterationTotal,
  };
}
